import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('execucao', 'execucao');


const execucaoActions = {
  listar: { method: 'GET', url: `${basePath}/meta/{id}` },
  remover: { method: 'DELETE', url: `${basePath}/{idExecucao}` },
};

export default resource => resource(`${basePath}`, {}, execucaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/execucao.js